import { TFunction } from "i18next";

import { DropdownCategory } from "@/api";
import { assertUnreachable } from "@/common/helper/commonHelper";

export function getDropdownCategoryLabel(category: DropdownCategory, t: TFunction): string {
  switch (category) {
    case DropdownCategory.Salutation:
      return t("settings.dropdowns.categories.Salutation");
    case DropdownCategory.Title:
      return t("settings.dropdowns.categories.Title");
    case DropdownCategory.Citizenship:
      return t("settings.dropdowns.categories.Citizenship");
    case DropdownCategory.MediaInquiry:
      return t("settings.dropdowns.categories.MediaInquiry");
    case DropdownCategory.ContactSource:
      return t("settings.dropdowns.categories.ContactSource");
    case DropdownCategory.Country:
      return t("settings.dropdowns.categories.Country");
    case DropdownCategory.City:
      return t("settings.dropdowns.categories.City");
    case DropdownCategory.EmploymentStatus:
      return t("settings.dropdowns.categories.EmploymentStatus");
    case DropdownCategory.AssignmentPriority:
      return t("settings.dropdowns.categories.AssignmentPriority");
    case DropdownCategory.CaseNoteLocation:
      return t("settings.dropdowns.categories.CaseNoteLocation");
    case DropdownCategory.AppointmentLocation:
      return t("settings.dropdowns.categories.AppointmentLocation");
    case DropdownCategory.CaseNoteResult:
      return t("settings.dropdowns.categories.CaseNoteResult");
    case DropdownCategory.Qualification:
      return t("settings.dropdowns.categories.Qualification");
    case DropdownCategory.MaritalStatus:
      return t("settings.dropdowns.categories.MaritalStatus");
    case DropdownCategory.LivingSituation:
      return t("settings.dropdowns.categories.LivingSituation");
    case DropdownCategory.ClientGoalAndResult:
      return t("settings.dropdowns.categories.ClientGoalAndResult");
    case DropdownCategory.ClientMeasures:
      return t("settings.dropdowns.categories.ClientMeasures");
    case DropdownCategory.ClientCauses:
      return t("settings.dropdowns.categories.ClientCauses");
    case DropdownCategory.ClaimLegalBasis:
      return t("settings.dropdowns.categories.ClaimLegalBasis");
    case DropdownCategory.Team:
      return t("settings.dropdowns.categories.Team");
    case DropdownCategory.WorkArea:
      return t("settings.dropdowns.categories.WorkArea");
    case DropdownCategory.Recommendation:
      return t("settings.dropdowns.categories.Recommendation");
    case DropdownCategory.RegisteredBy:
      return t("settings.dropdowns.categories.RegisteredBy");
    case DropdownCategory.SrvCounselingType:
      return t("settings.dropdowns.categories.SrvCounselingType");
    case DropdownCategory.SrvCourseEntryResult:
      return t("settings.dropdowns.categories.SrvCourseEntryResult");
    case DropdownCategory.IdentityDocumentType:
      return t("settings.dropdowns.categories.IdentityDocumentType");
    default:
      return assertUnreachable(category);
  }
}
